export const selectLargeTransactionsLimitsByBrand = (state) => state.largeTransactionsLimitsByBrand;
const selectLargeTransactionLimitsLogsByCurrency = (state) => state.largeTransactionLogs;
export const selectLargeTransactionLimitsLogsByCurrencyData = (state) => selectLargeTransactionLimitsLogsByCurrency(state).data;
export const selectLargeTransactionLimitsLogsByCurrencyTotal = (state) => selectLargeTransactionLimitsLogsByCurrency(state).total;
export const selectBrandPlayerLimits = (state) => state.playerLimits;
export const selectBrandPeriodsLimits = (state) => state.periodsLimits;
